import { useFormatter } from 'next-intl';
import { useLocale } from 'next-intl';

export default function useFormatterPrice() {
  const appLocale = useLocale();
  const format = useFormatter();

  return (price: number, locale?: string) => {
    locale = locale ?? appLocale;
    let currencyType;
    switch (locale) {
      case 'en':
      case 'de':
      case 'fi':
        currencyType = 'EUR';
        break;
      case 'sv':
        currencyType = 'SEK';
        break;
      case 'pl':
        currencyType = 'PLN';
        break;
      case 'no':
      default:
        currencyType = 'NOK';
        break;
    }

    const formattedPrice = format.number(price, {
      style: 'currency',
      currency: currencyType,
      maximumFractionDigits: 0,
    });

    return formattedPrice;
  };
}
